import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AppInitializer } from '../models/app-initializer.model';
import { AppInitializerCms } from '../models/app-initializer-cms';

@Injectable({
    providedIn: 'root'
})
export class AppCmsUrlsInitializationService {

    appInitializer: AppInitializerCms;

    constructor(private http: HttpClient) { }

    appCmsUrlsInitialization() {
        return this.http.get(environment?.B2C_URL + '/cmsUrls.service?app=ADDONS').toPromise()
            .then(async (response: any) => {
                this.appInitializer = new AppInitializerCms();
                this.appInitializer.CMS_URLS = response?.CMS_URLS;
            })
            .catch((error) => {
                // When service fails, get the configurations from the backup
                this.prepareConfigurationBackup();

            });
    }

    prepareConfigurationBackup() {
        this.appInitializer = new AppInitializerCms();
    }
}